export default theme => ({
  imageRoot: {
    maxHeight: 330,
    height: 'auto',
    display: 'initial',
    width: '100%'
  },
  image: {
    height: 'auto',
  },

  widgetContainer: {
    textAlign: 'center'
  },
  widget: {
    // paddingTop: props => {
      // console.log(props.noPadding, props.padding, props.theme.spacing.unit)
      // return props.noPadding ? 0 : (props.padding ? props.padding : props.theme.spacing.unit)
    // },
  },
});

